import React from "react";

export default function HowAAWorks() {
  return (
    <section className="py-12 px-6 lg:px-20 bg-white text-gray-800 leading-relaxed text-justify">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-center text-blue-700">
          ஏ.ஏ. எப்படி செயல்படுகிறது
        </h1>

        <p className="mb-4">
          எங்கள் வழியை முழுமையாக பின்பற்றியவர்கள் மீண்டும் குடிபோதைக்கு
          அடிமையாவது அரிது. குணமடையாமல் போனவர்கள் எல்லாம் எங்களுடைய இந்த எளிய
          செயல் திட்டத்தை முழுமனதோடு பின்பற்ற நினைக்காதவர்கள் அல்லது பின்பற்ற
          முடியாதவர்கள்தான். பொதுவாக இவர்களெல்லாம் சுபாவத்திலேயே தங்களுக்கு தானே
          நேர்மையுடன் நடந்து கொள்ள முடியாதவர்கள் அப்படிப்பட்ட துரதிஷ்டசாலிகளும்
          இருக்கிறார்கள். அவர்களை குறை கூறிப் பயனில்லை. அவர்கள் அந்த மாதிரியாகவே
          பிறந்துவிட்டார்கள் எனத் தோன்றுகிறது. முழு நேர்மை தேவைப்படுகிற ஒரு
          முறையான வாழ்க்கைக்கு அவசியமான கிரகிக்கும்தன்மையும், வாழ்க்கையின்
          நெறிமுறைகளை வகுத்துக் கொள்ளும் தன்மையும் இயற்கையிலேயே பெறத் தவறி
          விட்டவர்கள். அவர்களுடைய வாய்ப்புகள் சராசரிக்கும் குறைவே. இவர்களில்
          சிலர் தீவிர மனக்கிளர்ச்சியிலும், மனச்சிதைவிலும் கஷ்டப்படுகிறார்கள்.
          ஆனால் இதில் பலர் இவ்வழிமுறைகளை நேர்மையாக பின்பற்றுவதன் மூலம் நல்வாழ்வு
          பெறலாம்.
        </p>

        <p className="mb-4">
          எங்களுடைய அனுபவங்கள் பொதுப்படையாக நாங்கள் எப்படியிருந்தோம். பின் என்ன
          நேர்ந்தது. நாங்கள் இப்பொழுது எப்படியிருக்கிறோம். என்பதைக் காட்டும்.
          நாங்கள் பெற்ற நல்ல வாழ்க்கையை நீங்களும் பெற விரும்பினால் அதற்காக
          நீங்கள் எதையும் செய்யத் தயாராக இருத்தல் வேண்டும்.
        </p>

        <p className="mb-4">
          இவற்றுள் சிலவற்றை கண்டு நாங்கள் பின் வாங்கினோம். இதைவிட எளிய,
          மென்மையான வழியைக் கண்டுபிடிக்கலாம் என நினைத்தோம் ஆனால் முடியவில்லை.
          ஆகவே தொடக்கத்திலிருந்தே பயமின்றி, முழுமனதோடு பின்வாங்காமல் இருங்கள்
          என்ற ஆவலில் மன்றாடிக் கேட்டுக் கொள்கிறோம். எங்களில் சிலர் எங்களுடைய
          பழைய கருத்துக்களை விடாமல் பிடித்துக் கொள்ள முயன்றோம். அதனால் எந்த ஒரு
          பலனும் கிடைக்கவில்லை. அவற்றை முற்றிலும் துறந்த போதுதான் பலன்
          ஏற்பட்டது.
        </p>

        <p className="mb-4">
          நாம் நினைவில் கொள்ள வேண்டியது நம்முடன் தொடர்புடைய மதுவானது வஞ்சகமான -
          திகைப்பூட்டும், சக்திமிகுந்த ஒன்றாகும். உதவியின்றி அதை வெல்ல முடியாது.
          ஆனால் மிகுந்த வல்லமை படைத்த ஒருவன் இருக்கிறான். அவன் தான் இறைவன்...
          இப்போது “அவரை” நாம் உறுதியாக பற்றிக்கொள்வோமாக.
        </p>

        <p className="mb-4">
          அரைகுறை முயற்சியால் எங்களுக்கு பலன் கிடைக்கவில்லை. நாங்கள் ஒரு
          திருப்புமுனைக்கு வந்தாகி விட்டது. நாம் இறைவனுடைய பாதுகாப்பையும்,
          ஆதரவையும், அரவணைப்பையும் வேண்டினோம்.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4 text-blue-600">
          இதோ நாங்கள் பின்பற்றிய வழிமுறைகள்
        </h2>

        <p className="mb-4">
          குடியிலிருந்து மீள நீங்களும் இந்த வழிமுறையை பின்பற்றலாம்.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4 text-blue-600">
          ஏஏவின் பன்னிரெண்டு வழிமுறைகள்:
        </h2>

        <ol className="list-decimal pl-6 space-y-2">
          <li>
            மதுவைப் பொறுத்தவரை நாங்கள் சக்தியற்றவர்கள் என ஒப்புக்கொண்டோம் —
            வாழ்க்கையை எங்களால் சரிவர நடத்த முடியவில்லை.
          </li>
          <li>
            எங்களை விட வலிமை பொருந்திய சக்தி எங்களுக்கு மீண்டும் மனத்தெளிவை
            அளிக்கக்கூடும் என்ற நம்பிக்கைக்கு வந்தோம்.
          </li>
          <li>
            நாங்கள் புரிந்து கொண்ட இறைவனின் பொறுப்பில் எங்கள் சித்தத்தையும்
            வாழ்க்கையையும் ஒப்படைக்க முடிவு செய்தோம்.
          </li>
          <li>
            அச்சமின்றி எங்களைப் பற்றிய ஆழ்ந்த தார்மீக குணப்பட்டியல் தயார்
            செய்தோம்.
          </li>
          <li>
            இறைவனிடமும், எங்களிடமும் மற்றொருவரிடமும் எங்கள் தவறுகளின் உண்மையான
            தன்மையை ஒப்புக் கொண்டோம்.
          </li>
          <li>
            இறைவன் எங்களின் இந்த எல்லாக் குணக் குறைபாடுகளை அகற்ற நாங்கள் முழு
            மனதோடு எங்களைத் தயார்படுத்திக் கொண்டோம்.
          </li>
          <li>எங்களுடைய குறைபாடுகளை நீக்கும்படி இறைவனை பணிவோடு வேண்டினோம்.</li>
          <li>
            நாங்கள் யாருக்கெல்லாம் தீமை செய்தோம் என்ற பட்டியல் தயாரித்து
            அவற்றிற்குப் பரிகாரம் செய்யத் தயாரானோம்.
          </li>
          <li>
            எங்களால் பாதிக்கப்பட்டவர்களுக்கோ மற்றவர்களுக்கோ தீங்கு
            விளைவிக்காவண்ணம் கூடுமான வரையில் நேரிடையாக பரிகாரம் செய்தோம்.
          </li>
          <li>
            தொடர்ந்து சுயபரிசீலனை செய்தோம். தவறு செய்த போதெல்லாம் உடனடியாக
            ஒப்புக் கொண்டோம்.
          </li>
          <li>
            பிரார்த்தனை மற்றும் தியானத்தின் மூலம் நாங்கள் புரிந்து கொண்ட
            இறைவனிடம் உள்ளார்ந்த தொடர்பை வளர்த்துக் கொள்ள முயற்சித்தோம்.
            எங்களுக்காக அவன் சித்தம் என்னவென்று அறிந்து கொள்ளும் அறிவை, மட்டுமே
            வேண்டி அதை நிறைவேற்றும் சக்தியை கோரி பிரார்த்தித்தோம்.
          </li>
          <li>
            இவ்வழிமுறைகளைப் பின்பற்றியதன் பலனாக ஆன்மீக விழிப்பைப் பெற்றோம். இந்த
            வழிமுறைகளை மற்றக் குடி நோயாளிகளுக்கு எடுத்துக் கூற முயற்சித்தோம்.
            மேலும் இந்தத் தத்துவங்களை எங்கள் வாழ்க்கையின் எல்லா அம்சங்களிலும்
            கடைபிடிக்க முயற்சித்தோம்.
          </li>
        </ol>

        <p className="mt-8 italic text-gray-700 text-center">
          "எளிதாக செயல்படு — (யாவும்) எளிதாகிவிடும்"
        </p>

        <h2 className="text-2xl font-semibold mt-10 mb-4 text-blue-600">
          துணிவு இழக்காதீர்கள்
        </h2>

        <p className="mb-4">
          எங்களில் பலர் எவ்வளவு கடினமான முறை இது. இவற்றை எங்களால் பின்பற்ற
          முடியாது என வியந்தோம். துணிவு இழக்காதீர்கள். எங்களில் யாரும்
          இவ்வழிமுறைகளை முழுமையாக பின்பற்ற இயலவில்லை. நாங்கள் துறவிகள் அல்ல.
          ஆன்மீகப் பாதையில் முன்னேற நாங்கள் விரும்புகிறோம் என்பது தான்
          முக்கியமானது.
        </p>

        <p className="mb-4">
          நாங்கள் ஆன்மீக வளர்ச்சி அடைகின்றோமே தவிர அதில் முழு நிலை அடைந்து
          விட்டோம் என்று சொல்லவில்லை. குடிநோயைப் பற்றிய எங்களது விளக்கங்கள்,
          பகுத்தறிவு வாதி பற்றி எழுதிய அத்தியாயம் மற்றும் எங்களது கசப்பான
          அனுபவங்கள் இவையெல்லாம் எங்களுக்கு மூன்று முக்கியமான கருத்துகளை
          தெளிவாக்குகின்றன.
        </p>

        <ul className="list-disc pl-6 space-y-2">
          <li>
            நாங்கள் குடிநோயாளிகள், எங்கள் வாழ்க்கையை சரிவர நடத்த முடியவில்லை.
          </li>
          <li>
            எந்த ஒரு மனித சக்தியும் எங்களைக் குடி நோயிலிருந்து மீட்க முடியவில்லை
            என்றே சொல்ல வேண்டும்.
          </li>
          <li>இறைவனை நாடினால் அவரால் விடுவிக்க முடியும். விடுவிப்பார்.</li>
        </ul>
      </div>
    </section>
  );
}
